import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSidebarState } from 'hooks';
import { useSafes } from 'store';

// TODO change to some type of route guard
// currently this hook injected in every component that has route with :safeId para
// better to move that logic to some utility func and use it as a route guard
export const useActivateSafeFromUrlParam = () => {
  const { safeAddress, safeId } = useParams<{ safeAddress?: string; safeId?: string }>();
  const { currentSafeId, setCurrentSafeId } = useSidebarState();
  const { safes } = useSafes();

  useEffect(() => {
    const safeFromUrl = safes.find(
      (s) => (safeAddress && s.address === safeAddress) || s._id === safeId
    );
    if (safeFromUrl && (!currentSafeId || currentSafeId !== safeFromUrl._id)) {
      setCurrentSafeId(safeFromUrl._id);
    } else {
      Boolean(safeId) && setCurrentSafeId(safeId || '');
    }
  }, [safeAddress, safes, safeId]);
};
